import { render, staticRenderFns } from "./commerceClassroom.vue?vue&type=template&id=e08032ae&scoped=true&"
import script from "./commerceClassroom.vue?vue&type=script&lang=js&"
export * from "./commerceClassroom.vue?vue&type=script&lang=js&"
import style0 from "./commerceClassroom.vue?vue&type=style&index=0&id=e08032ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08032ae",
  null
  
)

export default component.exports